module.exports = __webpack_public_path__ + "img/13.10.pH.a8707dc9.png";